module.exports = __webpack_public_path__ + "components/flag/static/square/ga-1aed663e4aeb9c88febe837afde2d243.svg";